import i18n from 'i18next';
import HttpApi from 'i18next-http-backend'; // have a own http fallback
import { initReactI18next } from 'react-i18next';

const isProduction = process.env.NODE_ENV === 'production';

void i18n
  .use(initReactI18next)
  .use(HttpApi)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    returnNull: false,
    debug: !isProduction,
    fallbackLng: 'en',
    defaultNS: 'DS.SmartgatePlatform.ModelRegistry',
    saveMissing: !isProduction, // you should not use saveMissing in production
    // keySeparator: false,

    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    }
  });

export default i18n;
